module.exports = __webpack_public_path__ + "img/t1_raf_pt_wing_bolt.prt.68e67ed1.jpg";